package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import kotlin.String
import com.jingfangpai.common.orm.mapping.Prescription

object PrescriptionApiClient :BaseServiceClient() {

	@JsName("getById")
	fun getById(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Prescription>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"id" to "${id?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Prescription> = httpClient.get {
				    url("/api/prescription/getById?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getDetail")
	fun getDetail(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.prescription.model.PrescriptionDetail>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"id" to "${id?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.prescription.model.PrescriptionDetail> = httpClient.get {
				    url("/api/prescription/detail?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getIdNameList")
	fun getIdNameList( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.data.model.IdName>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.data.model.IdName>> = httpClient.get {
				    url("/api/prescription/listIdNames?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getList")
	fun getList( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.Prescription>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.Prescription>> = httpClient.get {
				    url("/api/prescription/list?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("save")
	fun save(prescription:com.jingfangpai.common.orm.mapping.Prescription, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Prescription>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Prescription> = httpClient.post {
				    url("/api/prescription/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.Prescription.serializer(),prescription), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
